import type { SupportedBCP47Locale, SupportedLocales } from '../types/locale'

import { normalizeLocale } from './normalizeLocale'

export function createExtractedMessagesGetter<L extends SupportedBCP47Locale>(
  messagesMap: Record<L, Record<string, string>>,
  defaultLocale: NoInfer<L>
): (locale?: SupportedLocales | SupportedBCP47Locale) => Record<string, string> {
  return (locale) => {
    const key = (locale ? normalizeLocale(locale, defaultLocale) : defaultLocale) as L
    return messagesMap[key] ?? messagesMap[defaultLocale]
  }
}
